import { CanActivateFn, Router } from '@angular/router';
import { AuthGuardService } from './auth/auth-guard.service';
import { inject } from '@angular/core';
import { ModulePermissionControllerCheckPermissionsToAccessPath200Response } from '@api-swagger-client/index';
import { map, tap, switchMap } from 'rxjs/operators';
import { MenuService } from './layout/app.menu.service';

export const authGuard: CanActivateFn = (route, state) => {
    const menuService = inject(MenuService);
    const authService = inject(AuthGuardService);
    const router = inject(Router);

    return menuService.ensureMenuLoaded().pipe(

        switchMap(() => {
            const permissions = menuService.getPermissionsForRoute(state.url);

            return authService.isAllowed(state.url);
        }),
        tap((response: ModulePermissionControllerCheckPermissionsToAccessPath200Response | any) => {
            if (!response.data) {
                router.navigate(['/unauthorized']);

                setTimeout(() => {
                    router.navigate(['/home']);
                }, 2000);
            }
        }),
        map((response) => response.data ?? false)
    );
};
